import {VIEW_TYPES} from "../../utils/constants"
import {DATE_RANGE_TEXT, MONTHLY_TEXT, MOST_RECENT_TEXT} from "./MainPageConstants"

export const GetReportForNewDairy = (dairyId, reports, viewType, reportType) => {
	return reports.find(report => report.report_dairy_id === dairyId)
}

export const GetMostRecentReport = (dairyId, reportsList) => {
	if(!reportsList){
		return null
	}
	
	for(let i = 0; i < reportsList.length; i++){
		const report = reportsList[i]
		if(report.report_dairy_id === dairyId){
			return report
		}
	}
}

export const FormatViewTypeStatusText = viewType => {
	switch (viewType){
		case VIEW_TYPES.DATE_RANGE:
			return DATE_RANGE_TEXT
		case VIEW_TYPES.MONTHLY:
			return MONTHLY_TEXT
		case VIEW_TYPES.MOST_RECENT:
			return MOST_RECENT_TEXT
		default:
			return viewType
	}
}